import { memo } from 'react';
import { Link, useSearchParams } from 'react-router';
import { Col, Container, ListGroup, Row } from 'react-bootstrap';
import ROUTES from '../../../constants/routes';
import CONSTANTS from '../../../constants';

const FooterWithLinks = () => {
	//#region useSearchParams

	const [searchParams, setSearchParams] = useSearchParams();

	//#endregion

	return (
		<footer className="pt-2 footer" style={{ background: '#121212' }}>
			<Container>
				<Row className="mb-1">
					<Col lg={12} md={12} sm={12}>
						<ListGroup
							as="ul"
							bsPrefix="list-unstyled"
							className="nav nav-footer flex-row nav-x-1 justify-content-center"
						>
							<ListGroup.Item as="li" bsPrefix=" ">
								<Link to={{ pathname: ROUTES.CONTACT, search: searchParams.toString() }} className="nav-link">
									Contact Us
								</Link>
							</ListGroup.Item>
							{/* <ListGroup.Item as="li" bsPrefix=" ">
									<Link to={{ pathname: ROUTES.LANDING, search: searchParams.toString() }} className="nav-link">
										Refer a Friend
									</Link>
								</ListGroup.Item> */}
							<ListGroup.Item as="li" bsPrefix=" ">
								<Link target="_blank" to={{ pathname: ROUTES.PRIVACY, search: searchParams.toString() }} className="nav-link">
									Privacy Policy
								</Link>
							</ListGroup.Item>
							<ListGroup.Item as="li" bsPrefix=" ">
								<Link target="_blank" to={{ pathname: ROUTES.TERMS, search: searchParams.toString() }} className="nav-link">
									Terms of Use
								</Link>
							</ListGroup.Item>
							<ListGroup.Item as="li" bsPrefix=" ">
								<Link target="_blank" to={{ pathname: ROUTES.COOKIES, search: searchParams.toString() }} className="nav-link">
									Cookie Policy
								</Link>
							</ListGroup.Item>
							<ListGroup.Item as="li" bsPrefix=" ">
								<Link target="_blank" to={{ pathname: ROUTES.COMMUNICATION_POLICY, search: searchParams.toString() }} className="nav-link">
									Communication Policy
								</Link>
							</ListGroup.Item>
						</ListGroup>
					</Col>
				</Row>

				<Row className="align-items-center g-0 border-top py-2 mt-1">
					{/* Desc  */}
					<Col lg={12} md={12} sm={12} className="text-center">
						<span className="text-center">{`Copyright © ${new Date().getFullYear()} ${CONSTANTS.COMPANY_NAME}. All rights reserved.`}</span>
						<div></div>
					</Col>
				</Row>
			</Container>
		</footer>
	);
};

export default memo(FooterWithLinks);